class ApiIntegrationTestConnection {
    constructor(testIntegrationButton){
        const thisClass = this;
        naja.makeRequest('GET', '?do=testIntegration', {
            'apiIntegrationId': testIntegrationButton,
            'organizationID': new URLSearchParams(window.location.search).get('organizationID')
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response) {
                $('#test_integration_modal').modal('show');
                thisClass.copyInit('test-integration-copy-url','test_integration_modal', $('#test-integration-url-input').val());
                thisClass.copyInit('test-integration-copy-header','test_integration_modal', $('#test-integration-header-input').val());
                thisClass.copyInit('test-integration-copy-curl','test_integration_modal', 'test');
                $('#test-integration-connection').on('click', function () {
                    thisClass.testConnection();
                });

            }
        });
    }

    copyInit(targetId, modalId, value){
        const target = document.getElementById(targetId);
        let clipboard = new ClipboardJS(target, {
            container: document.getElementById(modalId),
            target: target,
            text: function () {
                return value;
            }
        });

        clipboard.on('success', function (e) {
            const currentLabel = target.innerHTML;
            if (target.innerHTML === 'Copied!') {
                return;
            }
            // Update button label
            target.innerHTML = 'Copied!';
            // Revert button label after 3 seconds
            setTimeout(function () {
                target.innerHTML = currentLabel;
            }, 3000);
        });
    }
    testConnection(){
        $.ajax({
            url: '?do=testIntegrationConnection',
            type: 'POST',
            dataType: ''
        }).done(function (data) {
            if(data.connected){

                $('#test-integration-connection-status').addClass('text-success');
                $('#test-integration-connection-status').removeClass('text-danger');
                $('#test-integration-connection-status').html('Connection successful');
            } else {
                $('#test-integration-connection-status').removeClass('text-success');
                $('#test-integration-connection-status').addClass('text-danger');
                $('#test-integration-connection-status').html('Connection failed');
            }
        });
    }
}
window.ApiIntegrationTestConnection = ApiIntegrationTestConnection;
